import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';

type Props = Pick<ImEventDto, 'latitude' | 'longitude'>;

export const GeoMapLinkButton: React.FC<Props> = ({ latitude, longitude }) => {
  return (
    <Button
      variant="contained"
      sx={{
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}
      target="_blank"
      href={`https://www.google.co.jp/maps/?q=${latitude},${longitude}`}
    >
      行き方を調べる
      <OpenInNewIcon fontSize="small" />
    </Button>
  );
};
